import { createSlice } from "@reduxjs/toolkit";
import { getChefsDashboardCountAPI } from "../../api/dashboard";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const getChefsDashboardCountSlice = createSlice({
  name: "getChefsDashboardCount",
  initialState: data,
  reducers: {
    getChefsDashboardCountSlice(state) {
      state.isLoading = true;
    },
    getChefsDashboardCountSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getChefsDashboardCountSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getChefsDashboardCountSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getChefsDashboardCountHandler =
  (data: any) => async (dispatch: any) => {
    try {
      dispatch(getChefsDashboardCountAction.getChefsDashboardCountSlice());
      const response: any = await getChefsDashboardCountAPI(data);

      dispatch(
        getChefsDashboardCountAction.getChefsDashboardCountSliceSuccess(
          response
        )
      );
    } catch (e: any) {
      dispatch(
        getChefsDashboardCountAction.getChefsDashboardCountSliceFailure(
          e?.response?.data
        )
      );
    }
  };
export default getChefsDashboardCountSlice.reducer;
export const getChefsDashboardCountAction = getChefsDashboardCountSlice.actions;
